import ListInstruments from '@/Wist-blockchain/instruments/view/user/listInstruments'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/instruments/listInstruments',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) throw redirect({ to: '/login' })
    const { isServicioTecnico, isAdmin } = context.userRoles
    if (!isServicioTecnico && !isAdmin) throw redirect({ to: '/unauthorized' })
  },
  component: ListInstruments,
})

